module.exports = __webpack_public_path__ + "static/img1-ae422d8d6ec9f97a15d237d1ef72df26.jpg";